module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Light-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Light-webfont.woff
// module id = 1628
// module chunks = 0